"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    specificationVersion: {
        current: '2.0.3',
        exceptions: [],
    },
};
